import { render, staticRenderFns } from "./gameServerList.vue?vue&type=template&id=2455657a&"
import script from "./gameServerList.vue?vue&type=script&lang=js&"
export * from "./gameServerList.vue?vue&type=script&lang=js&"
import style0 from "./gameServerList.vue?vue&type=style&index=0&id=2455657a&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2455657a')) {
      api.createRecord('2455657a', component.options)
    } else {
      api.reload('2455657a', component.options)
    }
    module.hot.accept("./gameServerList.vue?vue&type=template&id=2455657a&", function () {
      api.rerender('2455657a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/gameServerList.vue"
export default component.exports